module.exports = __webpack_public_path__ + "static/media/feed.681236d9.svg";